module.exports = __webpack_public_path__ + "img/2@2x.261bf9dc.png";